import styled from 'styled-components'

export const ContainerCavalo = styled.div`
  margin: 30px 0 10px 0;
  div {
    margin-bottom: 5px;
  }
`

export const ContainerCarreta = styled.div`
  margin: 30px 0 10px 0;
  width: 100%;
  div {
    margin-bottom: 5px;
  }
  & .MuiAutocomplete-root {
    max-width: 300px;
  }
`
